module.exports = __webpack_public_path__ + "img/1-low.ecad149b.png";